import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CFormDynamiqueComponent } from './c-form-dynamique.component';
import { IonicModule } from '@ionic/angular';
import { CFormDynamiqueAllFieldsModule } from '../../c-form-dynamique-all-fields/c-form-dynamique-all-fields.module';



@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    CFormDynamiqueAllFieldsModule,
  ],
  declarations: [CFormDynamiqueComponent],
  exports: [CFormDynamiqueComponent],
})
export class CFormDynamiqueModule { }
